import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { TrAutocompleteModule } from './tr-autocomplete/tr-autocomplete.module';
import { TrCheckboxModule } from './tr-checkbox/tr-checkbox.module';
import { TrDateModule } from './tr-date/tr-date.module';
import { TrDocModule } from './tr-doc/tr-doc.module';
import { TrEmailModule } from './tr-email/tr-email.module';
import { TrMoneyModule } from './tr-money/tr-money.module';
import { TrNumberModule } from './tr-number/tr-number.module';
import { TrPasswordModule } from './tr-password/tr-password.module';
import { TrRadioModule } from './tr-radio/tr-radio.module';
import { TrSelectModule } from './tr-select/tr-select.module';
import { TrTelModule } from './tr-tel/tr-tel.module';
import { TrTextModule } from './tr-text/tr-text.module';
import { TrTypeaheadModule } from './tr-typeahead/tr-typeahead.module';
import { TooltipDirectiveModule } from './../../directives';

/**
 * All Toro Inputs
 */
@NgModule({
    imports: [
        TrAutocompleteModule,
        TrCheckboxModule,
        TrDateModule,
        TrDocModule,
        TrEmailModule,
        TrMoneyModule,
        TrNumberModule,
        TrPasswordModule,
        TrRadioModule,
        TrSelectModule,
        TrTelModule,
        TrTextModule,
        TrTypeaheadModule,
        TooltipDirectiveModule
    ],
    exports: [
        TrAutocompleteModule,
        TrCheckboxModule,
        TrDateModule,
        TrDocModule,
        TrEmailModule,
        TrMoneyModule,
        TrNumberModule,
        TrPasswordModule,
        TrRadioModule,
        TrSelectModule,
        TrTelModule,
        TrTextModule,
        TrTypeaheadModule,
    ],
    declarations: [],
    providers: [],
})
export class TrInputsModule {}
